module.exports = __webpack_public_path__ + "media/show_tip_2.aa882db0.wav";